<!--
 * @message:
 * @Author: cjc
 * @since: 2019-12-16 16:12:13
 * @lastTime     : 2019-12-26 14:21:53
 * @LastAuthor   : cjc
 -->
<template>
  <div class="menu-comp">
    <ul class="nav-wrapper">
      <li class="nav-item" v-for="(item, index) in nav" :key="index">
        <a v-if="item.name === 'fans'" :href="item.href" @click='fbTrack'>
          <img class="btn" :class="item.name" src="@/assets/images/img_trans.png" />
        </a>
        <a v-else :href="item.href">
          <img class="btn" :class="item.name" src="@/assets/images/img_trans.png" />
        </a>
        <span class="after"></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'menu-comp',
  data () {
    return {
      nav: [
        {
          name: 'home',
          href: '/'
        },
        {
          name: 'notice',
          href: '/notice'
        },
        {
          name: 'strategy',
          href: '/strategy'
        },
        {
          name: 'fans',
          href: 'https://www.facebook.com/%E5%BB%B6%E7%A6%A7%E7%A7%98%E4%BC%A0-103162351155987/'
        }
      ]
    }
  },
  methods: {
    fbTrack () {
      // eslint-disable-next-line no-undef
      fbq('track', 'Contact')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/mixins.scss";
@import "../assets/styles/variable.scss";

.menu-comp {
  .nav-wrapper {
    @include p-absolute(0, 0, top, right);
    @include setIndex($menu-layer);
    @include flex-center;
    .nav-item a {
      @include p-relative(-20px, 0);
    }
    .nav-item .after {
      display: inline-flex;
      margin: 0 15px 0 0;
      @include size(43px, 166px);
      @include setBg("../assets/images/lantern.png");
      vertical-align: middle;
    }
    .nav-item:last-child {
      margin-right: 30px;
    }
    .nav-item:last-child span {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue